import React from "react";
import { NavLink, NavLinkProps } from "@mantine/core";
import {
    NavLink as RRNavLink,
    NavLinkProps as RRNavLinkProps,
    useMatch,
    useResolvedPath,
} from "react-router-dom";

const MenuLink = (props: NavLinkProps & RRNavLinkProps) => {
    const { to, ...rest } = props;

    const resolved = useResolvedPath(to);
    const match = useMatch({ path: resolved.pathname, end: true });

    return (
        <NavLink
            to={to}
            active={match ? true : false}
            component={RRNavLink}
            {...rest}
        />
    );
};

export default MenuLink;
